import logo from "../images/brand/chaperon-logo-header.svg"

import SiteMenu from "./SiteMenu"
import SearchBox from "./SearchBox"
import UserMenu from "./UserMenu"

export default function Header({
    notificationsCount = 0,
    onShowNotifications,
}) {
    return (
        <header
            className="py-3 mb-3 border-bottom fixed-top"
            style={{ backgroundColor: "white" }}
        >
            <div
                className="container-fluid d-grid gap-3 align-items-center"
                style={{ gridTemplateColumns: "1fr 2fr" }}
            >
                <SiteMenu logo={logo} />
                <div className="d-flex align-items-start">
                    <SearchBox />

                    <UserMenu
                        notificationsCount={notificationsCount}
                        onShowNotifications={onShowNotifications}
                    />
                </div>
            </div>
        </header>
    )
}
